export const CSVToObject = (dataStr, delimiter = ';') => {
    const data = dataStr.trim().split('\n');
    const result = [];
    if (data.length > 1 && data[0].length > 0 && data[1].length > 0) {
        const headers = unQuote(data.shift().split(delimiter));

        for (let i in data) {
            const row = unQuote(data[i].split(delimiter));
            const rowObj = createMultipleObjects(headers, row);
            delete rowObj.type;
            delete rowObj.recipient;
            result.push(rowObj);
        }
    }
    return result;
};

export const createMultipleObjects = (headers, data) => {
    const origin = {};
    headers.map((header, index) => {
        const keys = header.split('__');

        if (keys.length === 1) {
            origin[header] = data[index];
        }

        if (keys.length === 2) {
            if (!Object.keys(origin).includes(keys[0])) {
                origin[keys[0]] = {};
            }
            origin[keys[0]][keys[1]] = data[index];
        }

        if (keys.length > 2) {
            if (!Object.keys(origin).includes(keys[0])) {
                origin[keys[0]] = {};
            }
            if (!Object.keys(origin[keys[0]]).includes(keys[1])) {
                origin[keys[0]][keys[1]] = [{}];
            }
            origin[keys[0]][keys[1]][0][keys[2]] = data[index];
        }
    });

    return origin;
};
export const processHeader = (header) => {
    const keys = header.split('__'),
        r = {};

    if (keys.length === 1) {
        r[header] = '';
    }

    if (keys.length === 2) {
        r[keys[0]] = {};
        r[keys[0]][keys[1]] = '';
    }

    if (keys.length > 2) {
        r[keys[0]] = {};
        r[keys[0]][keys[1]] = [];
        const item = {};
        item[keys[2]] = '';
        r[keys[0]][keys[1]].push(item);
    }
    return r;
};

export const unQuote = (row) => {
    return row.map((str) => {
        if (str.at(0) === '"' && str.at(-1) === '"') {
            str = str.slice(1, -1);
        }
        return str;
    });
};

export const useCSV = async () => {
    return {
        CSVToObject: CSVToObject,
        unQuote: unQuote,
    };
};

export default useCSV;
